import React, { useState, useContext } from "react";
import { styled, useTheme } from "@mui/material/styles";
import { Avatar } from '@mui/material';
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import DashboardOutlined from "@mui/icons-material/DashboardOutlined";
import CloseOutlined from "@mui/icons-material/CloseOutlined";
import { AuthContext } from "../contexts/AuthContext";
import { Outlet, Link } from "react-router-dom";
import { ListaMenu } from "../components/home/ListaMenu";
import { convertirLetraMayus } from "../helpers/convertirLetraMayus";

const drawerWidth = 240;

const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: "hidden",
});

const closedMixin = (theme) => ({
    transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up("sm")]: {
        width: `calc(${theme.spacing(8)} + 1px)`,
    },
});

const DrawerHeader = styled('div')(({ theme, open }) => {
    return open ? ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(3, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar
    }) : ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar
    })
});

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== "open" })(({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    boxSizing: "border-box",
    ...(open && {
        ...openedMixin(theme),
        "& .MuiDrawer-paper": openedMixin(theme),
    }),
    ...(!open && {
        ...closedMixin(theme),
        "& .MuiDrawer-paper": closedMixin(theme),
    }),
}));

export const Home = () => {

    const theme = useTheme();
    const [open, setOpen] = useState(false);
    const { usuario } = useContext(AuthContext);

    const handleDrawerOpen = () => setOpen(true);

    const handleDrawerClose = () => setOpen(false);

    return (
        <Box sx={{ display: "flex", minHeight: '100vh' }}>
            <CssBaseline />
            <AppBar position="fixed" open={open}>
                <Toolbar style={{ backgroundColor: "#00365F" }}>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        edge="start"
                        sx={{
                            marginRight: 5,
                            ...(open && { display: "none" }),
                        }}
                    >
                        <DashboardOutlined />
                    </IconButton>

                    <Typography variant="h5" noWrap component="div" fontWeight={600}>
                        <Link to="/home" style={{ color: '#fff', textDecoration: 'none' }}>
                            Tail
                        </Link>
                    </Typography>
                </Toolbar>
            </AppBar>
            <Drawer variant="permanent" open={open}>
                <DrawerHeader>
                    {open && (
                        <div
                            style={{
                                height: 150,
                                display: "flex",
                                justifyContent: "center",
                                width: "100%",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    flexFlow: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: "100%"
                                }}
                            >
                                <Avatar
                                    style={{
                                        width: 50,
                                        height: 50,
                                        background: "#81c784",
                                        fontWeight: "bold",
                                    }}
                                >
                                    {usuario?.nombre.charAt(0).toUpperCase() +
                                        usuario?.nombre.charAt(1).toUpperCase()}
                                </Avatar>
                                <span
                                    style={{
                                        fontSize: 14,
                                        color: "#424242",
                                        fontWeight: "600",
                                        textTransform: "capitalize",
                                        marginTop: 5,
                                    }}
                                >
                                    {usuario?.nombre}
                                </span>

                                <div style={{ display: 'flex', gap: 1 }}>
                                    <span style={{ fontSize: 13, fontWeight: 600, color: '#616161' }}>{ convertirLetraMayus(usuario?.rol?.nombre) }</span>
                                </div>
                            </div>

                            <IconButton
                                style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                }}
                                onClick={handleDrawerClose}
                            >
                                {theme.direction === "rtl" ? (
                                    <CloseOutlined fontSize="small" />
                                ) : (
                                    <CloseOutlined fontSize="small" />
                                )}
                            </IconButton>
                        </div>
                    )}
                </DrawerHeader>

                <Divider />

                <ListaMenu />
            </Drawer>
            <Box
                component="main"
                sx={{ flexGrow: 1, p: 1, background: "#f5f5f5" }}
            >
                {/* Contenido dashboard */}
                <DrawerHeader />
                <Outlet />
            </Box>
        </Box>
    );
}